var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.fetchState.pending)?_c('div',[_c('div',[_vm._v("loading...")])]):(_vm.fetchState.error)?_c('div',[_c('div',[_vm._v(_vm._s(_vm.$t('main.fetch-error')))])]):_c('div',{domProps:{"innerHTML":_vm._s(_vm.agreementHtml)}})])}
var staticRenderFns = []

export { render, staticRenderFns }